(function () {
  function slugify(str) {
    return String(str)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function storageKey(retailer) {
    return 'ny_signup_popup_' + slugify(retailer || 'default');
  }

  function getState(retailer) {
    try {
      return window.localStorage.getItem(storageKey(retailer));
    } catch (e) {
      return null;
    }
  }

  function setState(retailer, value) {
    try {
      window.localStorage.setItem(storageKey(retailer), value);
    } catch (e) {
      /* localStorage unavailable (e.g. private mode) — popup just won't remember dismissal */
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function initPopup(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var retailer = container.dataset.retailer || '';
    var companyId = container.dataset.companyId;
    var listId = container.dataset.listId;
    var delayMs = parseInt(container.dataset.delayMs, 10) || 4000;

    if (getState(retailer)) return; // already dismissed or subscribed

    var form = container.querySelector('[data-signup-form]');
    var errorEl = container.querySelector('[data-signup-error]');
    var submitBtn = container.querySelector('[data-signup-submit]');
    var body = container.querySelector('[data-signup-body]');
    var closeEls = container.querySelectorAll('[data-signup-close]');

    function show() {
      container.classList.add('is-visible');
      container.setAttribute('aria-hidden', 'false');
    }

    function hide() {
      container.classList.remove('is-visible');
      container.setAttribute('aria-hidden', 'true');
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        hide();
        setState(retailer, 'dismissed');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && container.classList.contains('is-visible')) {
        hide();
        setState(retailer, 'dismissed');
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorEl.hidden = true;

      var email = form.email.value.trim();
      if (!isValidEmail(email)) {
        errorEl.textContent = 'Please enter a valid email address.';
        errorEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      retailer: retailer,
                      signup_source: 'NY Landing Page Popup',
                    },
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: listId } },
            },
          },
        }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Request failed');
          setState(retailer, 'subscribed');
          body.innerHTML =
            '<p class="email-signup-popup__success-heading">THANKS!</p>' +
            '<p class="email-signup-popup__success-subheading">You’re signed up for updates.</p>';
          setTimeout(hide, 2500);
        })
        .catch(function () {
          errorEl.textContent = 'Something went wrong. Please try again.';
          errorEl.hidden = false;
          submitBtn.disabled = false;
        });
    });

    setTimeout(show, delayMs);
  }

  function init() {
    document.querySelectorAll('.email-signup-popup[data-retailer]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
